export default __webpack_public_path__ + "static/media/CPF All About.c6186af3.mp4";